<template>
  <div style="width:100%" class="elevation-2 pt-3 pl-3 pr-3">
    <Loading :value="loading"></Loading>
    <h4 mt-2>MATRICE PROJET</h4>
    <v-divider></v-divider>
    <v-layout wrap mt-3>
      <!-- <v-flex xs12 >
        <v-layout row class="mb-4 mt-1">
            <v-flex md4 class="mr-1">
              <el-select   filterable  @change="filtrerChantier()" v-model="chantierS" placeholder="Selectionner un Chantier" style="width:100%">
                  <el-option v-for="item in listeChantier" :key="item.id" :label="item.libelle" :value="item.id">
                  </el-option>
              </el-select>
            </v-flex>
        </v-layout>
      </v-flex>-->

      <!-- <v-flex xs12>
           <el-select   filterable  @change="filtrerRptAValid()" v-model="rptAValid" placeholder="Selectionner" style="width:100%">
                  <el-option v-for="item in listeChantier" :key="item.id" :label="item.libelle" :value="item.id">
                  </el-option>
              </el-select>
      </v-flex>-->

       <v-flex xs12 class="text-xs-right">
         <v-tooltip top>
           <v-btn
             v-if="true"
             slot="activator"
             color="orange"
             :disabled="false"
             @click.stop="imprimeMatricePDF()"
             dark
           >
             Imprimer
             <v-icon right>print</v-icon>
           </v-btn>Imprimer la matrice
         </v-tooltip>

            <v-btn
                icons
                color="primary"
                @click="showAjoutDoc()"
                dark
              >
                Ajouter
                <v-icon right>add</v-icon>
              </v-btn>
      </v-flex>

      <v-flex xs12 class="elevation-1">
        <data-tables :data="listeDoc" border style="width:100%;">
          <el-table-column type="expand">
            <template slot-scope="props">
                <el-row class="ml-3">
                    <el-col :span="5">
                        <div class="ml-2" >

                                <b>Description</b> : <p>{{ props.row.commentaire }}</p>

                        </div>
                    </el-col>

                    <el-col :span="19">
                       <div>
                          <b>Versions du document</b> :
                        </div>
                        <div class="elevation-1">

                          <el-table
                          :data="props.row.versions"
                          style="width: 100%">
                          <el-table-column
                            prop="libelle"
                            label="IDENTIFIANT"
                           >
                          </el-table-column>
                          <el-table-column
                            prop="dateCreated"
                            label="DATE"
                           >
                          </el-table-column>
                           <el-table-column
                            prop="userCreated"
                            label="ENREGISTRER PAR"
                            >
                          </el-table-column>
                          <el-table-column
                            prop="libStatus"
                            label="Status"
                            >
                          </el-table-column>

                          <el-table-column
                            prop="mode"
                            label="MODE DE TRANSMISSION">
                          </el-table-column>

                          <el-table-column
                            prop="dateSend"
                            label=" DATE DE TRANSMISSION">
                          </el-table-column>

                           <!-- <el-table-column
                            prop="commentaire"
                            label="COMMENTAIRE">
                          </el-table-column> -->

                           <el-table-column label="ACTION" align="center" width="100" fixed="right">
                            <template slot-scope="scop">

                               <v-btn
                                 :disabled="props.row.close"
                                  @click.native="showDialogVersionEdit(scop.row)"
                                  slot="activator"
                                  color="orange"
                                  fab
                                  dark
                                 flat
                                  small
                                >
                                  <v-icon>edit</v-icon>

                                </v-btn>

                                 <v-btn
                                 @click.native="showDialogVersionDetail(scop.row)"
                                  slot="activator"
                                  color="primary"
                                  fab
                                  dark
                                 flat
                                  small
                                >
                                  <v-icon>description</v-icon>

                                </v-btn>
                               <v-btn
                                  :disabled="props.row.close"
                                  @click.native="showDialogSuppVersion(scop.row)"
                                  slot="activator"
                                  color="red"
                                  fab
                                  dark
                                  flat
                                  small
                                >
                                  <v-icon>delete</v-icon>

                                </v-btn>
                            </template>
                          </el-table-column>




                        </el-table>



                        </div>

                    </el-col>

                </el-row>




            </template>
          </el-table-column>
          <el-table-column prop="ordre" label="N ORDRE" align="center" width="230" ></el-table-column>
          <el-table-column prop="libelle" label="LIBELLE" align="center" width="230" ></el-table-column>
          <el-table-column prop="categorie" label="CATEGORIE" align="center" width="230" ></el-table-column>

          <el-table-column prop="numDoc" label="NUMERO DOCUMENT" align="center"></el-table-column>
           <el-table-column prop="status" label="STATUS" align="center"></el-table-column>
          <el-table-column prop="userCreated" label="ENREGISTRE PAR" align="center"></el-table-column>

          <el-table-column label="ACTION" align="center" width="200" fixed="right">
            <template slot-scope="scope">
              <v-tooltip bottom>
                <v-btn v-if="scope.row.close == false"  @click.native="showAddVersion(scope.row)" slot="activator" color="purple" fab dark small>
                  <v-icon>description</v-icon>
                </v-btn>Version
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn @click.native="showEditDoc(scope.row)" slot="activator" color="orange" fab dark small>
                  <v-icon>edit</v-icon>
                </v-btn>Modifier
              </v-tooltip>

              <v-tooltip bottom>
                <v-btn
                  @click.native="showDilogSupp(scope.row)"
                  slot="activator"
                  color="red"
                  fab
                  dark
                  small
                >
                  <v-icon>delete</v-icon>
                </v-btn>Supprimer
              </v-tooltip>
            </template>
          </el-table-column>
        </data-tables>
      </v-flex>
    </v-layout>

    <!-- MODAL SUPPRESSION DEMANDE -->
    <v-dialog v-model="dialogSupr" persistent max-width="50%" v-if="!droitAcces.delete_matrice">
      <v-card>
        <v-card-title class="headline">Supprimer cet enregistrement ?</v-card-title>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 class="mb-2">
              <el-alert
                title="La suppression est définitive"
                :closable="false"
                show-icon
                type="warning"
              ></el-alert>
            </v-flex>
            <v-flex xs12>
              <p class="grey--text font-weight-thin body-1">DOCUMENT</p>
              <p class="black--text .font-weight-regular subheading">NUMERO-12345</p>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" dark @click="dialogSupr = false">
            Annuler
            <v-icon right>remove_circle</v-icon>
          </v-btn>
          <v-btn
            color="red darken-1"
            dark
            @click="deleteDoc()"
          >
            Supprimer
            <v-icon right>delete</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- MODAL SUPPRESSION DEMANDE -->

    <!-- MODAL SUPPRESSION VERSION -->
    <v-dialog v-model="dialogSuprVers" persistent max-width="50%" >
      <v-card>
        <v-card-title class="headline">Supprimer cet enregistrement ?</v-card-title>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 class="mb-2">
              <el-alert
                title="La suppression est définitive"
                :closable="false"
                show-icon
                type="warning"
              ></el-alert>
            </v-flex>
            <v-flex xs12>
              <p class="grey--text font-weight-thin body-1">DOCUMENT</p>
              <p class="black--text .font-weight-regular subheading">version-{{versionSelect.libelle}}</p>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" dark @click="dialogSuprVers = false">
            Annuler
            <v-icon right>remove_circle</v-icon>
          </v-btn>
          <v-btn
            color="red darken-1"
            dark
            @click="deleteVersion()"
          >
            Supprimer
            <v-icon right>delete</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- MODAL SUPPRESSION VERSION -->

    <!-- MODAL AJOUT DOC -->
         <v-dialog v-model="dialogDoc" width="80%" :persistent="true"  transition="dialog-bottom-transition" scrollable  >
            <v-card tile>
                <v-toolbar card dark color="primary">
                    <v-toolbar-title>Ajouter ou modifier un document</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click.native="dialogDoc = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <el-form id="formDoc"  :model="formDoc" :rules="rulesFormDoc" ref="formDoc" class="demo-form-inline">
                        <v-layout row>
                            <v-flex xs4 class="mr-1" >
                                <el-form-item label="Numéro d'ordre" prop="ordre">
                                <el-input  v-model="formDoc.ordre" name="ordre" placeholder="N ordre"  style="width: 100%"></el-input>
                            </el-form-item>
                            </v-flex>

                             <v-flex xs4 class="mr-1" >
                                <el-form-item label="Libellé" prop="libelle">
                                <el-input  v-model="formDoc.libelle" name="libelle" placeholder="libelle"  style="width: 100%"></el-input>
                            </el-form-item>
                            </v-flex>

                             <v-flex xs4 class="mr-1" >
                                 <el-form-item label="Catégorie" prop="categorie">
                                <el-select  v-model="formDoc.categorie" name="categorie" placeholder="Catégorie" style="width: 100%">
                                    <el-option v-for="item in categories" :key="item.value" :label="item.text" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                             </v-flex>


                        </v-layout>

                        <v-layout row>

                             <v-flex xs4 class="mr-1" >
                                 <el-form-item label="Numéro du document" prop="numDoc">
                                    <el-input  v-model="formDoc.numDoc" name="numDoc" placeholder="Numéro document"  style="width: 100%" ></el-input >
                                </el-form-item>
                              </v-flex>

                               <v-flex xs4 v-if="editForm == false" class="mr-1" >
                                 <el-form-item label="Version" prop="version">
                                    <el-input  v-model="formDoc.version" name="version" placeholder="Version"  style="width: 100%" ></el-input>
                                </el-form-item>
                              </v-flex>


                           <v-flex xs4 class="mr-1" v-if="editForm == false" >
                                 <el-form-item label="Mode de transmission" prop="mode">
                                <el-select  v-model="formDoc.mode" name="mode" placeholder="Mode de transmission" style="width: 100%">
                                    <el-option v-for="item in mode" :key="item.value" :label="item.text" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                             </v-flex>

                              <!-- <v-flex xs4 class="mr-1" >
                                 <el-form-item label="Status" prop="status">
                                <el-select  v-model="formDoc.status" name="status" placeholder="Status" style="width: 100%">
                                    <el-option v-for="item in status" :key="item.value" :label="item.text" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                             </v-flex> -->

                        </v-layout>
                        <v-layout row>

                             <v-flex xs4 class="mr-1">
                              <el-form-item label="Date de transmission" required style="width:100%">
                                  <!-- <el-date-picker v-model="formDoc.dateSend"  :disabled="!newVersion" value-format="dd-MM-yyyy" type="date" id="dateSend" name="dateSend" placeholder="Date" style="width:100%">
                                  </el-date-picker> -->
                                  <el-date-picker v-model="formDoc.dateSend"   value-format="dd-MM-yyyy" type="date" id="dateSend" name="dateSend" placeholder="Date" style="width:100%">
                                  </el-date-picker>
                              </el-form-item>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                              <v-flex xs4 class="mr-1" >
                                   <el-form-item label="Description" prop="commentaire">
                                <el-input type="textarea" :rows="10"  v-model="formDoc.commentaire" name="commentaire" placeholder="commentaire"  style="width: 100%"></el-input>
                            </el-form-item>
                              </v-flex>

                              <v-flex xs4 class="ml-3" >
                                  <p class="font-weight-thin" >Format (JPEG,PNG,PDF), 10 Mo maximum</p>
                                   <a :href="logoMatrice" target="_blank">
                                      <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="logoMatrice" alt="avatar"></v-avatar><br/>
                                  </a>
                                      <input name="docs" type="file" style="display:none" ref="fileLogo" accept="image/*" @change="onFileImageLogoPicked"/>
                                      <v-btn color="primary" class="white--text" required @click.native="$refs.fileLogo.click()">Document  <v-icon right dark>cloud_upload</v-icon></v-btn><br/>
                            </v-flex>


                        </v-layout>



                        <v-layout row >
                            <v-flex xs12 class="mt-2">
                            <el-form-item  class="text-xs-right" >
                               <v-btn color="grey"  @click="dialogDoc = false" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
                               <v-btn v-if="editForm == false" icons dark color="green" @click="addDoc('formDoc')">Enregistrer<v-icon right>save</v-icon></v-btn>
                               <v-btn v-else  icons dark color="green" @click="editDoc('formDoc')">Modifier<v-icon right>edit</v-icon></v-btn>
                            </el-form-item>
                            </v-flex>
                        </v-layout>
                    </el-form>
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>

    <!-- MODAL AJOUT DOC  -->

     <!-- MODAL AJOUT VERSION -->
         <v-dialog v-model="dialogVersion" width="70%" :persistent="true"  transition="dialog-bottom-transition" scrollable  >
            <v-card tile>
                <v-toolbar card dark color="primary">
                    <v-toolbar-title>Ajouter une version au document </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click.native="dialogVersion = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <el-form id="formVersion"  :model="formVersion" :rules="rulesFormVersion" ref="formVersion" class="demo-form-inline">
                        <v-layout row>
                            <v-flex xs4 class="mr-1" >
                                <el-form-item label="Identifiant(version)" prop="ordre">
                                  <el-input :disabled="!newVersion"  v-model="formVersion.libelle" name="identifiant" placeholder="Identifiant de la version"  style="width: 100%"></el-input>
                                </el-form-item>
                            </v-flex>

                             <v-flex xs4 class="mr-1" >
                                 <el-form-item label="Mode de transmission" prop="mode">
                                <el-select  :disabled="!newVersion"   v-model="formVersion.mode" name="mode" placeholder="Mode de transmission" style="width: 100%">
                                    <el-option v-for="item in mode" :key="item.value" :label="item.text" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                             </v-flex>

                              <v-flex xs4 class="mr-1"  v-show="newVersion == false" >

                                  <el-form-item label="Date de transmission"  style="width:100%">
                                    <el-date-picker v-model="formVersion.dateSend"  value-format="dd-MM-yyyy" format="dd-MM-yyyy" type="date" id="dateSend"  name="dateSend" placeholder="Date" style="width:100%">
                                  </el-date-picker>
                                  </el-form-item>
                              </v-flex>

                               <v-flex xs2 class="mr-1" v-show="newVersion == false" >
                                 <el-form-item label="Status" prop="statut">
                                <el-select   v-model="formVersion.status" name="status" placeholder="Status" style="width: 100%">
                                    <el-option v-for="item in status" :key="item.value" :label="item.text" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                             </v-flex>

                               <v-flex xs2 class="ml-3" >
                                <p class="font-weight-thin" >Format (JPEG,PNG,PDF), 10 Mo maximum</p>
                                <p v-if="versionCourante.extention=='gif' || versionCourante.extention=='PNG' ||versionCourante.extention=='JPEG' || versionCourante.extention=='jpg'|| versionCourante.extention=='JPG'" >
                                  <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4">
                                    <img :src="formVersion.urlImage" alt="avatar"/>
                                  </v-avatar>
                                </p>

                                <p v-if="versionCourante.extention=='pdf' || versionCourante.extention=='PDF'">
                                  <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4">
                                    <a :href="formVersion.urlImage" target="_blank"><iframe :src="formVersion.urlImage"></iframe>
                                    Cliquer içi pour afficher le pdf</a>
                                  </v-avatar>
                                </p>
                                 <v-layout row>
                                    <input  name="docs" type="file" style="display:none" ref="file1" accept="image/*|pdf" @change="onFileImagePickedVersion"/>
                                        <v-btn  color="primary" class="white--text" required @click.native="$refs.file1.click()">Document  <v-icon right dark>cloud_upload</v-icon></v-btn>

                                </v-layout>
                            </v-flex>


                        </v-layout>

                        <v-layout row>

                             <v-flex xs6 class="mr-1" >
                                   <el-form-item label="Description" prop="commentaire">
                                <el-input type="textarea" :disabled="!newVersion" :rows="10"  v-model="formVersion.commentaire" name="commentaire" placeholder="commentaire"  style="width: 100%"></el-input>
                            </el-form-item>
                              </v-flex>

                                 <v-flex xs6 class="mr-1" v-show="newVersion == false" >
                                   <el-form-item label="Reserve" prop="reserve">
                                <el-input type="textarea" :rows="10"  v-model="formVersion.reserve" name="reserve" placeholder="reserve"  style="width: 100%"></el-input>
                            </el-form-item>
                              </v-flex>

                        </v-layout>

                        <v-layout row >
                            <v-flex xs12 class="mt-2">
                            <el-form-item  class="text-xs-right" >
                               <v-btn color="grey" v-show="newVersion == true"  @click="resetFormVersion()" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
                               <v-btn v-if="newVersion == true" icons dark color="green" @click="addVersion('formVersion')">Enregistrer<v-icon right>add</v-icon></v-btn>
                               <v-btn v-else :disbaled="!verifEditVersion" icons dark color="green" @click="editVersion('formVersion')">Modifier<v-icon right>edit</v-icon></v-btn>
                            </el-form-item>
                            </v-flex>
                        </v-layout>
                    </el-form>
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>

    <!-- MODAL AJOUT VERSION  -->

    <!-- MODAL SHOW VERSION -->
    <v-dialog v-model="dialogShowVersion" max-width="50%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>Détails de la version {{versionCourante.libelle}} </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogShowVersion = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text>
          <el-row :gutter="20">
            <div class="grid-content bg-purple">
              <el-card class="box-card"  style="background:#F9FAFC">
                <div class="text item">
                  <v-layout row wrap>
                    <v-flex md6>
                      <p v-if="versionCourante.extention=='gif' || versionCourante.extention=='PNG' ||versionCourante.extention=='JPEG' || versionCourante.extention=='jpg'|| versionCourante.extention=='JPG'" >
                        <a :href="versionCourante.urlImage" target="_blank">
                            <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4">
                                <img :src="versionCourante.urlImage" alt="avatar"/>
                                         Cliquer içi pour afficher l'image
                                  </v-avatar>
                        </a>
                      </p>

                       <p v-if="versionCourante.extention=='pdf' || versionCourante.extention=='PDF'">
                        <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4">
                          <a :href="versionCourante.urlImage" target="_blank"><iframe :src="versionCourante.urlImage"></iframe>
                          Cliquer içi pour afficher le pdf</a>

                          <!-- <img :src="versionCourante.imageDoc" alt="avatar"/> -->
                        </v-avatar>
                      </p>



                      <p><b>Identifiant : </b> {{versionCourante.libelle}} </p>
                      <p><b>Mode de transmission : </b> {{versionCourante.mode}} </p>
                    </v-flex>
                    <v-flex md6>
                      <p><b>Statut : </b> {{versionCourante.libStatus}} </p>
                      <p><b>Ajouter par : </b> {{versionCourante.userCreated}} </p>
                      <p><b>Commentaire :</b> {{versionCourante.commentaire}}  </p>
                      <p><b>Réserve :</b> {{ versionCourante.reserve }} </p>
                      <p><b>Date d'enregistrement :</b> {{ versionCourante.dateCreated}} </p>
                    </v-flex>
                  </v-layout>
                </div>
              </el-card>

              <v-tooltip top>
                <v-btn slot="activator" icons color="orange" @click.stop="dialogShowVersion = false" dark>Fermer <v-icon right>close</v-icon></v-btn>
                Fermer
              </v-tooltip>
              <v-tooltip top>
              <v-btn slot="activator" icons color="primary" @click.stop="showDialogVersionEdit(versionCourante)" dark>Mofifier <v-icon right>edit</v-icon></v-btn>
              Modifier
            </v-tooltip>
            </div>
          </el-row>
        </v-card-text>


        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>
    <!-- END MODAL SHOW VERSION -->

  </div>
</template>

<script>
import Loading from "@/components/Loading";

export default {
  components: { Loading },
  name: "MatriceContract",
  props: {
    show: {
      type: Boolean
    },
    idProjet:{
        type: Number
    }

  },
  data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      loading: false,
      roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
      droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),

      formDoc:{
        ordre:"",
        libelle: "",
        categorie:0,
        numDoc: "",
        version: "",
        mode:0,
        commentaire:"",
         file: null,
         urlImage: "/static/doc.png"
      },
      editForm: false,
      dialogShowVersion: false,
      dialogSupr: false,
      listeDoc:[],
      dialogDoc: false,
      status: [
          {
            text: "EN ATTENTE",
            value: 0
          },
          {
            text: "ACO",
            value: 1
          },
           {
            text: "AC1",
            value: 2
          },
           {
            text: "BPE",
            value: 3
          }

      ],
       rulesFormDoc: {

                ordre: [
                    { required: true, message: 'Veuillez saisir' },

                ],
                 libelle: [
                    { required: true, message: 'Veuillez saisir' },

                ],
                 categorie: [
                    { required: true, message: 'Veuillez selectionner' },

                ],
                 numDoc: [
                    { required: true, message: 'Veuillez saisir'},

                ],
                version: [
                    { required: true, message: 'Veuillez saisir', trigger: 'change' },

                ],
                 mode: [
                    { required: true, message: 'Veuillez selectionner', trigger: 'blur' },
                ],
                 status: [
                    { required: true, message: 'Veuillez selectionner', trigger: 'blur' },
                ],


            },

        mode: [
          {
            text: "Courrier",
            value: 0
          },
          {
            text: "Mail",
            value: 1
          },
      ],
        rulesFormVersion: {

                identifiant: [
                    { required: true, message: 'Veuillez saisir' },

                ],
                 mode: [
                    { required: true, message: 'Veuillez selectionner', trigger: 'blur' },
                ],
            },

        mode: [
          {
            text: "Courrier",
            value: 0
          },
          {
            text: "Mail",
            value: 1
          },
      ],

       categories: [
          {
            text: "Autorisation",
            value: 0
          },
          {
            text: "Environnement sociale",
            value: 1
          },
          {
            text: "ETUDE",
            value: 2
          },
      ],
      versionCourante: [],
      // Attributs de filtres
      selectCategorieMatrice: null,
      selectStatusMatrice: null,
      selectSaverMatrice: null,
      selectModeMatrice: null,
      logoMatrice: '/static/img-doc.png',

      docSelect : {
        numDoc: ""
      },
      dialogVersion : false,
       formVersion:{
         libelle:"",
         commentaire: "",
         file: null,
         urlImage: "/static/doc.png"
      },
      newVersion: true,
      versionSelect: {
        libelle: ""
      },
      dialogSuprVers: false,



    };
  },


  watch: {
    show: function(newValue, oldvalue) {
      if (newValue == true) {
       this.loadDoc()
        this.onglet = "0";
        // this.loadReserves();
        // this.loadBesoinAvalider()
        // this.loadRapportProjet();
      }
    }
  },

  methods: {

    showDialogVersionDetail(item) {
      this.dialogShowVersion = true
      this.versionCourante = item
    },

    showDialogSuppVersion(item){
      this.versionSelect = item;
      this.dialogSuprVers = true;
    },
    showDilogSupp(item) {
      this.docSelect = item;
      this.dialogSupr = true;
    },
    loadDoc(){
        this.loading = true;
        this.docSelect = null;
        let url = this.domaine + "matrice/projet/"+this.idProjet;
         this.$http.get(url).then(
                        response => {

                            this.loading = false;
                            console.log("body ", response.body);
                            this.listeDoc = response.body.listeDoc;

                        },
                        response => {
                        this.loading = false;
                        console.log(" erreur lors du  chargement des documents");
                        }
                    );

    },
    showAjoutDoc(){
        this.editForm =  false
        this.resetForm();
        this.dialogDoc = true;
        this.logoMatrice = '/static/img-doc.png';
    },
   imprimeMatricePDF () {
      let tab = []
      let userid = this.user.id
      this.listeDoc.forEach((element) => {
          tab.push(element.idDoc)
      })
      let url = this.domaine + 'matrice/imprimer_matrice_pdf/'+userid+'/liste/'+ tab
      window.open(url)
    },
    showDialogVersionEdit(item)
    {
        this.dialogVersion = true;
       this.newVersion = false;
       this.versionSelect = item;
        this.formVersion = item;
        console.log('this.formVersion',this.formVersion)
      //  this.formVersion.libelle = item.libelle
      //  this.formVersion.mode = item.modeS
      this.formVersion.urlImage = item.urlImage
      //  this.formVersion.description = item.commentaire
       //this.formVersion.status =  item.status
      // this.formVersion.reserve = item.reserve

    },
    showAddVersion(item){
        this.newVersion = true;

      if(item.attente == true){
        this.$message.error("Veuillez modifier l'etat de la derniere version du document")
        return;
      }
        console.log("add version item ", item);
        this.docSelect = item;

        this.resetFormVersion()

        this.dialogVersion = true;

    },
    addVersion(formName){
         //this.editForm =  false
         console.log("docselect",this.docSelect)
         this.$refs[formName].validate((valid) => {
            if (valid) {
                 this.loading = true;
                 let form = document.getElementById("formVersion")
                  let data = new FormData(form);
                  let url =  this.domaine + 'matrice/new/version/'+this.docSelect.idDoc;
                  data.append("mode",this.formDoc.mode)
                  //data.append("status",this.formDoc.status)
                  data.append("userId",this.user.id)

                  this.$http.post(url, data).then(resp=>{
                      this.loading = false;
                       this.resetFormVersion();
                       this.dialogVersion = false;
                       this.loadDoc();
                       this.successNotif(resp.body.message)
                  },

                  error=>{
                       this.loading = false;
                       //this.resetForm('formDoc');
                       this.$message.error("Une erreur est survenue lors de l'enregistrement du document")
                  })

            }
         })
    },


    addDoc(formName){
         this.editForm =  false
         this.$refs[formName].validate((valid) => {
            if (valid) {
                 this.loading = true;
                 let form = document.getElementById("formDoc")
                  let data = new FormData(form);
                  let url =  this.domaine + 'matrice/create';
                  data.append("categorie",this.formDoc.categorie)
                  data.append("mode",this.formDoc.mode)
                  data.append("dateSend",this.formDoc.dateSend)
                  //data.append("status",this.formDoc.status)
                  data.append("userId",this.user.id)
                  data.append("projetId",this.idProjet)

                  this.$http.post(url, data).then(resp=>{
                     let verif = resp.body
                       if (verif.code === 0) {
                            this.loading = false;
                            this.resetForm();
                            this.dialogDoc = false;
                            this.loadDoc();
                            this.successNotif(verif.message)
                       }else{
                          this.loading = false
                          this.$message.error("Le numero d'ordre de ce documment existe deja")
                       }
                  },

                  error=>{
                       this.loading = false;
                       //this.resetForm('formDoc');
                       this.$message.error("Une erreur est survenue lors de l'enregistrement du document")
                  })

            }
         })
    },

    showEditDoc(item){

        //this.resetForm();
        console.log("item ", item.versions[0])

        this.formDoc = item;
        this.formDoc.dateSend = item.versions[0].dateSend;


        this.docSelect = item
        this.editForm = true;

        this.logoMatrice = item.versions[0].urlImage
        // this.formDoc.libelle = this.docSelect.libelle
        // this.formDoc.ordre = this.docSelect.ordre
        // //this.formDoc.categorie = this.docSelect.etatCategorie
        // this.formDoc.numDoc =  this.docSelect.numDoc
        // this.formDoc.version = this.docSelect.version
        // //this.formDoc.mode = this.docSelect.etatMode
        // //this.formDoc.status =  this.docSelect.etatStatus
        // this.formDoc.commentaire =  this.docSelect.commentaire
        // this.formDoc.file = null;
        // console.log("formDoc ",this.formDoc)


        this.dialogDoc = true;


    },
    editDoc(formName){
         this.editForm =  true
         this.$refs[formName].validate((valid) => {
            if (valid) {
                 this.loading = true;
                 let form = document.getElementById("formDoc")
                  let data = new FormData(form);
                  let url =  this.domaine + 'matrice/edit/'+this.docSelect.idDoc;
                  data.append("categorie",this.formDoc.categorie)
                  data.append("mode",this.formDoc.mode)
                  data.append("status",this.formDoc.status)
                  //data.append("userId",this.user.id)
                  //data.append("projetId",this.idProjet)

                  this.$http.post(url, data).then(resp=>{
                      this.loading = false;
                       this.resetForm();
                       this.dialogDoc = false;
                       this.loadDoc();
                       this.successNotif(resp.body.message)
                  },

                  error=>{
                       this.loading = false;
                       //this.resetForm('formDoc');
                       this.$message.error("Une erreur est survenue lors de la modification du document")
                  })

            }
         })
    },
     editVersion(){



                 this.loading = true;
                 let form = document.getElementById("formVersion")
                  let data = new FormData(form);
                  let url =  this.domaine + 'matrice/edit/version/'+this.versionSelect.id;
                  data.append("status",this.formVersion.status)
                  data.append("userId",this.user.id)
                  data.append("dateSend",this.formVersion.dateSend)
                  //data.append("projetId",this.idProjet)

                  this.$http.post(url, data).then(resp=>{
                      this.loading = false;
                       this.resetForm();
                       this.dialogVersion = false;
                       this.loadDoc();
                       this.successNotif(resp.body.message)
                  },

                  error=>{
                       this.loading = false;
                       this.resetForm('formDoc');
                       this.$message.error("Une erreur est survenue lors de la modification de la version")
                  })



    },
    deleteDoc(){
        this.loading = true;
        let url =
        this.domaine + "matrice/delete/" + this.docSelect.idDoc;
      this.$http.get(url).then(
        response => {
          this.loading = false;
          this.loadDoc()

          this.$notify({
            title: "SUPPRESSION",
            message: "Document supprimé avec succès.",
            type: "success",
            position: "top-center"
          });
          this.dialogSupr = false;
        },
        errRep => {
          this.loading = false;
          this.dialogSupr = false;
          this.$notify.error({
            title: "SUPPRESSION ECHOUEE",
            message: "La suppression du document a échouée.",
            position: "top-center"
          });
        }
      );
    },
     deleteVersion(){
        this.loading = true;
        let url =
        this.domaine + "matrice/delete/version/" + this.versionSelect.id;
      this.$http.get(url).then(
        response => {
          this.loading = false;
          this.loadDoc()

          this.$notify({
            title: "SUPPRESSION",
            message: "Document supprimé avec succès.",
            type: "success",
            position: "top-center"
          });
          this.dialogSuprVers = false;
        },
        errRep => {
          this.loading = false;
          this.dialogSupr = false;
          this.$notify.error({
            title: "SUPPRESSION ECHOUEE",
            message: "La suppression du document a échouée.",
            position: "top-center"
          });
        }
      );
    },
      successNotif(mess = "Document enregistré avec succès",type = "success"){
            this.$notify({
                    title: 'ENREGISTREMENT DOCUMENT',
                    message: mess,
                    type: type,
                    position: 'top-center',
                    duration: 10000
            })
        },

     resetForm() {
          console.log("resetForm")
          this.formDoc = [];
        this.file = null;
        //  this.$refs["formDoc"].resetFields();
         this.formDoc.urlImage="/static/doc.png";
         this.formDoc.file = null;
         //this.formDoc= {}
      },

       resetFormVersion() {
          console.log("resetForm")
         this.$refs['formVersion'].resetFields();
         this.formVersion.libelle="";
         this.formVersion.commentaire= "";
         this.formVersion.urlImage="/static/doc.png";
         this.formVersion.file = null;

      },
       //enregistrement des images
    onFileImageLogoPicked(event)
      {
          const files = event.target.files
          let filename = files[0].name
          if (filename.lastIndexOf(".") <= 0)
          {
              return alert("Veuillez selectionner un  format de fichier valide ")
          }

          const fileReader = new FileReader()
          fileReader.addEventListener("load", () => {
              this.logoMatrice = fileReader.result
          })

          fileReader.readAsDataURL(files[0])
          this.logoMatrice = files[0]

      },

     onFileImageMatrice(event)
        {
            console.log("onfileChnage files",event.target.files);
            const files = event.target.files
            let filename = files[0].name
            let extension = files[0].type
            if (filename.lastIndexOf(".") <= 0) {
                return alert("Veuillez selectionner un  format de fichier valide ")
            }
              if( files[0].size > 10485760  ){
                    this.$message.error("La taille du fichier est supérieur à 10M");
                    return;
                }


            const fileReader = new FileReader()
            fileReader.addEventListener("load", () => {
                console.log("loader addevent")
                this.formDoc.urlImage = fileReader.result
            })

            fileReader.readAsDataURL(files[0])

            this.formDoc.urlImage = files[0];

        },

       onFileImagePickedVersion(event)
            {
              //  this.formVersion.urlImage = "";
                console.log("onfileChnage files version",event.target.files);
                const files = event.target.files
                let filename = files[0].name
                if (filename.lastIndexOf(".") <= 0) {
                    return alert("Veuillez selectionner un  format de fichier valide ")
                }
                 if( files[0].size > 10485760  ){
                        this.$message.error("La taille du fichier est supérieur à 10M");
                        return;
                    }


                const fileReader = new FileReader()
                fileReader.addEventListener("load", () => {
                    console.log("loader addevent")
                    this.formVersion.urlImage =fileReader.result
                })

                fileReader.readAsDataURL(files[0])

                this.formVersion.file = files[0];

                console.log("file 0 ",files[0])
            },
      },

  computed: {
      verifEditVersion: function()
      {
                if(this.formVersion.status != null && this.formVersion.reserve != null ){
                    return true
                }else {
                    return false
                }
            },
  },

  mounted() {}
};
</script>




// WEBPACK FOOTER //
// src/components/projet/MatriceContract.vue